import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-neojobz-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './neojobz-header.component.html',
  styleUrl: './neojobz-header.component.scss'
})
export class NeojobzHeaderComponent implements OnInit, OnDestroy {

  currentRoute: string = '';
  private routerSub!: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.routerSub = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.currentRoute = event.urlAfterRedirects;
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }

  isActive(path: string): boolean {
    if (path === '/') {
      return this.currentRoute === '/';
    }
    return this.currentRoute === path || this.currentRoute.startsWith(path + '/') || this.currentRoute.startsWith(path + '?');
  }
}